import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconDelete.tsx
const OutlinedFilledDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M253-95q-39.46 0-67.23-27.47Q158-149.95 158-189v-553h-58v-94h231v-48h297v48h232v94h-58v553q0 39.05-27.77 66.53Q746.46-95 707-95H253Zm101-172h77v-399h-77v399Zm175 0h78v-399h-78v399Z" })
});
const OutlinedDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-58v-94h231v-48h297v48h232v94h-58v553q0 39.05-27.77 66.53Q746.46-95 707-95H253Zm454-647H253v553h454v-553ZM354-267h77v-399h-77v399Zm175 0h78v-399h-78v399ZM253-742v553-553Z" })
});
const RoundedFilledDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-11q-19.75 0-33.37-13.68Q100-769.35 100-789.18q0-19.82 13.63-33.32Q127.25-836 147-836h184q0-20 13.63-34 13.62-14 33.37-14h203q19.75 0 33.38 14.19Q628-855.63 628-836h185q19.75 0 33.38 13.68Q860-808.65 860-788.82q0 19.82-13.62 33.32Q832.75-742 813-742h-11v553q0 39.8-27.39 66.9Q747.21-95 707-95H253Zm139.68-172Q409-267 420-278.26T431-305v-323q0-15.47-11.31-26.74Q408.37-666 392.82-666 376-666 365-654.74q-11 11.27-11 26.74v323q0 15.48 11.18 26.74Q376.35-267 392.68-267Zm175.69 0q15.63 0 27.13-11.26Q607-289.52 607-305v-323q0-15.47-11.57-26.74Q583.86-666 567.93-666t-27.43 11.26Q529-643.47 529-628v323q0 15.48 11.87 26.74Q552.74-267 568.37-267Z" })
});
const RoundedDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M253-95q-40.21 0-67.61-27.1Q158-149.2 158-189v-553h-11q-19.75 0-33.37-13.68Q100-769.35 100-789.18q0-19.82 13.63-33.32Q127.25-836 147-836h184q0-20 13.63-34 13.62-14 33.37-14h203q19.75 0 33.38 14.19Q628-855.63 628-836h185q19.75 0 33.38 13.68Q860-808.65 860-788.82q0 19.82-13.62 33.32Q832.75-742 813-742h-11v553q0 39.8-27.39 66.9Q747.21-95 707-95H253Zm454-647H253v553h454v-553ZM392.68-267Q409-267 420-278.26T431-305v-323q0-15.47-11.31-26.74Q408.37-666 392.82-666 376-666 365-654.74q-11 11.27-11 26.74v323q0 15.48 11.18 26.74Q376.35-267 392.68-267Zm175.69 0q15.63 0 27.13-11.26Q607-289.52 607-305v-323q0-15.47-11.57-26.74Q583.86-666 567.93-666t-27.43 11.26Q529-643.47 529-628v323q0 15.48 11.87 26.74Q552.74-267 568.37-267ZM253-742v553-553Z" })
});
const SharpFilledDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M354-267h77v-399h-77v399Zm175 0h78v-399h-78v399ZM158-95v-647h-58v-94h231v-48h297v48h232v94h-58v647H158Z" })
});
const SharpDelete = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M158-95v-647h-58v-94h231v-48h297v48h232v94h-58v647H158Zm95-94h454v-553H253v553Zm101-78h77v-399h-77v399Zm175 0h78v-399h-78v399ZM253-742v553-553Z" })
});
const componentMap = {
	outlined: OutlinedDelete,
	"outlined-fill": OutlinedFilledDelete,
	rounded: RoundedDelete,
	"rounded-fill": RoundedFilledDelete,
	sharp: SharpDelete,
	"sharp-fill": SharpFilledDelete
};
const IconDelete = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconDelete };